/**
 * 生产计划管理
 */
 import axios from '../request';
 export default{
    /**
     * 管片原料理论放量
     */
    // 查询管片原料理论放量信息
    searchChainTheory: params =>
        axios({
            method: 'post',
            url: '/materials/chainTheory/findList',
            headers: {
              pageNum: params.pageNum,
              pageSize: params.pageSize
            },
            data:params
          }),
    // 添加管片原料理论放量信息
    insertOrUpdateChainTheory: params =>
        axios.post('/materials/chainTheory/save', params),
    // 删除管片原料理论放量信息
    deleteChainTheory: params =>
        axios.post('/materials/chainTheory/delete', params),
    //获取计划原料列表
    getPlanList: params =>
        axios.post('/materials/rsbMaterialPlan/info', params),
    //导出按钮
    // exportBtns: params =>
    //     axios.post('/usercore/sysUser/getAuthCode', params),
    exportBtns: params =>
        // axios.post('/materials/mixingstationstorage/statExport', params),
        axios({
        method: 'post',
        url: '/materials/',
        responseType: 'blob',
        data: params
    }),

    
 }